<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-input
          v-model="filter.search"
          :shadow="false"
          placeholder="Cari Kode"
          debounce
          @native-input="loadOrders"
          type="search"
        />
        <base-button :to="{ name: 'penjualan.kirim-promo.tambah' }"
          >Tambah</base-button
        >
      </div>
      <div>
        <datatable
          :columns="columns"
          :data="orders.data"
          :scroll-x="false"
          :total="orders.meta.page.total"
          :perPage="orders.meta.page.perPage"
          :currentPage="orders.meta.page.currentPage"
          :meta="orders.meta"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="(order) in orders.data"
              :key="order.id"
              :class="[
                classes.tr,
                'cursor-pointer bg-white hover:bg-green-100',
              ]"
              @click="
                onClickRow(
                  getSingleIncluded(orders, order.relationships.order.data.id)
                )
              "
            >
              <td :class="[classes.td]">
                <order-code-label :order="order" />
                <order-date-label
                  :order="order"
                  class="text-xs text-gray-500"
                />
              </td>
              <td :class="classes.td">
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.origin_warehouse_code
                }}
                /
                {{
                  getSingleIncluded(orders, order.relationships.order.data.id)
                    .attributes.destination_office_code
                }}
              </td>
              <td :class="[classes.td, 'text-center']" :title="getSingleIncluded(orders, order.relationships.order.data.id)
                .attributes.latest_cancel_description">
                <base-badge color="yellow">{{
                  order.attributes.order_status
                  }}</base-badge>
              </td>
              <td :class="[classes.td, 'text-center']">
                <base-badge color="indigo">{{
                  order.attributes.warehouse_status
                }}</base-badge>
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </div>
    <view-order-modal
      :visible="viewOrderModal.visible"
      :order-id="viewOrderModal.orderId"
      with-bonus
      :with-payment="false"
      :with-items="false"
      label="Kirim Stok Promo"
      printable
      :columns="[
        'code',
        'warehouse',
        'office',
        'date',
        'user',
        'area',
        'shipment_type',
        'address',
      ]"
      edit-route-name="restock-sc.edit"
      @close="viewOrderModal.visible = false"
      @validated="onValidated"
      @deleted="onDeleted"
    />
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';
import ViewOrderModal from '@/components/order/view-order-modal.vue';
import OrderDateLabel from '@/components/order/order-date-label.vue';
import OrderCodeLabel from '@/components/order/order-code-label.vue';

export default {
  mixins: [requestMixin],
  components: { ViewOrderModal, OrderDateLabel, OrderCodeLabel },
  data() {
    return {
      filter: {
        search: null,
      },
      orders: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      loading: false,
      viewOrderModal: {
        visible: false,
        orderId: null,
      },
    };
  },
  computed: {
    columns() {
      return [
        { id: 'code', name: 'No. Faktur' },
        { id: 'office_code', name: 'Kode Gudang / SC' },
        {
          id: 'order_status',
          name: 'Status',
          theadClass: 'text-center',
        },
        {
          id: 'warehouse_status',
          name: 'Status Gudang',
          theadClass: 'text-center',
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadOrders(params = {}) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/orders', {
        params: {
          'page[size]': 5,
          'filter[destination_office_category_id]': 3,
          include: 'order',
          'filter[search]': this.filter.search,
          'fields[simple-orders]':
            'orderedAt,order_type,reference_code,order_id,order,origin_code,destination_code,createdAt,order_status,warehouse_status',
          'fields[orders]':
            'destination_office_code,default_area_price,origin_warehouse_code,is_valid_for_packing,latest_cancel_description',
          'filter[is_transfer_promo]': true,
          'sort': '-id',
          ...params,
        },
      });

      if (!error) {
        this.orders = res;
      }

      this.loading = false;
    },
    onClickRow(order) {
      this.viewOrderModal.orderId = order.id;
      this.viewOrderModal.visible = true;
    },
    onPageChanged(page) {
      this.loadOrders({
        'page[number]': page,
      });
    },
    onValidated() {
      this.viewOrderModal.visible = false;
      this.loadOrders();
    },
    onDeleted() {
      this.viewOrderModal.visible = false;
      this.loadOrders();
    },
  },
  created() {
    this.loadOrders();
  },
};
</script>
